import { ProfileResource, profileResource } from '@witkac/kartamiejska-resources';
import { Profile, ProfileType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';
import userRole from './profile/userRole.module';

/**
 * Moduł profili
 *
 * @export
 * @class ProfilesModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class ProfilesModule extends EntityModule<Profile, ProfileResource> {
  public modules = { userRole };

  constructor() {
    super(profileResource);

    this.state = {
      ...this.state,
      data: {
        profile: {
          id: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          phoneNumber: undefined,
          companyName: undefined,
          companyPosition: undefined,
          userId: undefined,
          user: {
            userId: undefined,
            state: undefined
          }
        },
        login: undefined
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Pobiera identyfikator profilu na podstawie adresu e-mail
       *
       * @param context context
       * @param params paremetry do przekazania do resource
       * @param params.email adres e-mail
       * @param [params.type] typ profilu
       */
      findByEmail: async (context: any, params: { email: string; type?: ProfileType }): Promise<number> => {
        const id = await this.resource.findByEmail(params.email, params.type);
        context.commit('setId', id);
        return id;
      },

      /**
       * Pobiera identyfikator profilu na podstawie numeru pesel
       *
       * @param context context
       * @param params paremetry do przekazania do resource
       * @param params.pesel numer pesel
       * @param [params.type] typ profilu
       */
      findByPESEL: async (context: any, params: { pesel: string; type?: ProfileType }): Promise<number> => {
        const id = await this.resource.findByPESEL(params.pesel, params.type);
        context.commit('setId', id);
        return id;
      },

      /**
       * Pobiera identyfikator profilu na podstawie numeru telefonu
       *
       * @param context context
       * @param params paremetry do przekazania do resource
       * @param params.phoneNumber numer telefonu
       * @param [params.type] typ profilu
       */
      findByPhoneNumber: async (context: any, params: { phoneNumber: string; type?: ProfileType }): Promise<number> => {
        const id = await this.resource.findByPhoneNumber(params.phoneNumber, params.type);
        context.commit('setId', id);
        return id;
      },

      /**
       * Pobiera identyfikator profilu na podstawie numeru karty
       *
       * @param context context
       * @param params paremetry do przekazania do resource
       * @param params.cardNumber numer karty
       * @param [params.type] typ profilu
       */
      findByCardNumber: async (context: any, params: { cardNumber: string; type?: ProfileType }): Promise<number> => {
        const id = await this.resource.findByCardNumber(params.cardNumber, params.type);
        context.commit('setId', id);
        return id;
      },

      /**
       * Aktualizacja danych profilu
       *
       * @param {*} context
       * @param {{ id: number; profile: Profile }} data
       */
      update: async (context: any, data: { id: number; profile: Profile }) => {
        const userId = data.profile.userId;
        delete data.profile.userId;
        data.profile.id = await this.resource.update(data.id, data.profile);
        data.profile.userId = userId;
        context.commit('update', data.profile);
        context.commit('setEntity', data.profile);
      },

      /**
       * Dodaje profil użytkownika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        const args = { login: data.login, profile: data.profile };
        data.profile.id = await this.resource.add(args);
        context.commit('add', data.profile);
        context.commit('incrementCount');
      }
    };

    this.mutations = {
      ...this.mutations,
      /**
       * Zapis profilu do store
       *
       * @param {*} localState
       * @param {*} profile
       */
      setEntity(localState: any, profile: any): void {
        Object.keys(localState.data.profile)
          .filter(key => profile[key] !== undefined)
          .forEach(key => (localState.data.profile[key] = profile[key]));
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      }
    };
  }
}
export default new ProfilesModule();
